<template>

	<div>
		<!-- 添加弹出框 -->
		<el-dialog title="添加角色" :visible.sync="show" width="70%" top="2vh" :close-on-click-modal="false">

			<div style="height: 72vh ;overflow-y: auto;">

				<el-form :model="submit_data" ref="myForm" label-width="70px">
					<el-form-item label="角色名称" class="formName">
						<el-input v-model="submit_data.name"></el-input>
					</el-form-item>




					<!-- <el-form-item label="权限选择" label-width="90px">

						<el-checkbox-group v-model="array" v-for="(v,k) in check_lists">


							<el-checkbox :label="v.pass_action" :ref="v.pass_action" :data="v" v-if="v.name"
								@change="checkChange(v.pass_action,'1')">

								{{v.name}}


							</el-checkbox>

							<el-form-item></el-form-item>


							<el-checkbox-group v-model="array" v-for="(v1,k1) in v.sup_array"
								style="margin-left: 2%;margin-top: -1%;">


								<el-checkbox :label="v1.pass_action" :ref="v1.pass_action" :data="v1" v-if="v1.name"
									@change="checkChange(v1.pass_action,'2',v.pass_action)">

									{{v1.name}}


								</el-checkbox>

								<el-form-item></el-form-item>


								<el-checkbox-group v-model="array" style="margin-left: 2%;margin-top: -1%;">




									<el-checkbox v-for="(v2,k2) in v1.sup_array" :label="v2.pass_action" :ref="v2.pass_action" :data="v2"
										v-if="v2.name" @change="checkChange(v2.pass_action,'3',v.pass_action,v1.pass_action)">

										{{v2.name}}


									</el-checkbox>




									<el-form-item></el-form-item>

								</el-checkbox-group>


							</el-checkbox-group>



						</el-checkbox-group>



					</el-form-item> -->


					<el-form-item label="指派模式" label-width="90px">

						<el-checkbox-group v-model="assign_mode_submit">
							<el-checkbox label="assign">普通指派</el-checkbox>
							<el-checkbox label="ai">AI智能</el-checkbox>
						</el-checkbox-group>

					</el-form-item>

					<el-form-item label="订单导出乘客手机号:" label-width="150px">
						<el-switch v-model="submit_data.order_export_cp" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>
					<el-form-item label="司机充值权限:" label-width="150px">
						<el-switch v-model="submit_data.driver_wallet_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="续费签约权限:" label-width="150px">
						<el-switch v-model="submit_data.driver_sign_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>


					<el-form-item label="司机标记权限:" label-width="150px">
						<el-switch v-model="submit_data.driver_write_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="乘客充值权限:" label-width="150px">
						<el-switch v-model="submit_data.consumer_recharge_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="司机账面分权限:" label-width="150px">
						<el-switch v-model="submit_data.driver_driverpoints_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					 <el-form-item label="boss端登录权限:" label-width="150px">
            <el-switch
              v-model="submit_data.boss_login"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </el-form-item>


					<el-form-item label="订单发票导出:" label-width="150px">
						<el-switch v-model="submit_data.export_order_invoice" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="银行卡导出:" label-width="150px">
						<el-switch v-model="submit_data.export_bank_card" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="司机在线时长导出:" label-width="150px">
						<el-switch v-model="submit_data.export_order_count" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>



					<el-form-item label="定位红包:" label-width="150px">
						<el-switch v-model="submit_data.positioning_reward" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="角色备注">
						<el-input type="textarea" rows="5" v-model="submit_data.remarks"></el-input>
					</el-form-item>

				</el-form>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="cancel">取消</el-button>
<!--				<el-button type="primary" @click="addRoleSubmit">确定</el-button>-->
				<submitBtn @onSubmitDig="onSubmitDig" @toJSON="toJSON" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="true"></submitBtn>
			</span>

		</el-dialog>
	</div>
</template>
<script>
	var _this;
	export default {
		created() {

			_this = this;

		},


		// 接受父组件传的值
		props: {

			isShow: true,

		},
		// 监听父组件传过来的值
		watch: {

			isShow(newData, oldData) {
				console.log(_this.array);
				_this.adminClassLists();

				_this.show = true;

			}

		},
		data() {

			return {
				array: [],
				show: false,
				search_data: {},
				check_lists: {},
				assign_mode_submit:[],


				submit_url:'/system/addRoleSubmit',
				submit_data: {
					name: '',
					synchronization: [],
					remarks: '',
					driver_wallet_add:'0',
					order_export_cp:'0',
					driver_sign_add:'0',
					driver_write_add:'0',
					consumer_recharge_add:'0',
					driver_driverpoints_add:'0',
					boss_login:'0',
					export_order_invoice:'0',
					export_bank_card:'0',
					export_order_count:'0',
					positioning_reward:'0'
				},
				submit_rules: {
					name: {
						placeholder: '角色名',
						rules: {
							required: true,
							message: '角色名10个汉字以下',
							regulation: 'elt_str',
							rulesData: 10
						}
					},
					synchronization: {
						placeholder: '权限模块',
						rules: {
							required: false,
							message: '权限模块代码数组(json)',
							regulation: 'special',
							rulesData: 'json_array'
						}
					},
					remarks: {
						placeholder: '角色备注',
						rules: {
							required: false,
							message: '角色备注说明，200字节以内',
							regulation: 'lt_str',
							rulesData: 200
						}
					}
				},
			}
		},
		methods: {

			arrayDel(data) {
				for (let delindex = 0; delindex < _this.array.length; delindex++) {

					// 如果数组中存在需要删除的数据则删除
					if (_this.array[delindex] == data) {
						_this.array.splice(delindex, 1);
					}

				}
			},

			checkChange(e, level, firParent, secParent) {


				// switch (level) {
				// 	case '1':


				// 		// 如果点击的一级元素被选中
				// 		if (!(_this.$refs[e][0].isChecked)) {



				// 			if (_this.$refs[e][0].$attrs.data.sup_array) {

				// 				// 将对应的二级选中
				// 				for (let i = 0; i < _this.$refs[e][0].$attrs.data.sup_array.length; i++) {

				// 					_this.array.push(_this.$refs[e][0].$attrs.data.sup_array[i].pass_action)


				// 					// 数组去重
				// 					_this.array = [...new Set(_this.array)];

				// 					if (_this.$refs[e][0].$attrs.data.sup_array[i].sup_array) {

				// 						// 将对应的三级选中
				// 						for (let j = 0; j < _this.$refs[e][0].$attrs.data.sup_array[i].sup_array.length; j++) {

				// 							_this.array.push(_this.$refs[e][0].$attrs.data.sup_array[i].sup_array[j].pass_action)

				// 							// 数组去重
				// 							_this.array = [...new Set(_this.array)];
				// 						}

				// 					}

				// 				}

				// 			}



				// 		} else {

				// 			if (_this.$refs[e][0].$attrs.data.sup_array) {

				// 				// 遍历得到二级pass_action属性
				// 				for (let i = 0; i < _this.$refs[e][0].$attrs.data.sup_array.length; i++) {

				// 					// 需要在array中删除的数据
				// 					var delData2 = _this.$refs[e][0].$attrs.data.sup_array[i].pass_action;

				// 					_this.arrayDel(delData2);

				// 					if (_this.$refs[e][0].$attrs.data.sup_array[i].sup_array) {

				// 						// 遍历得到三级pass_action属性
				// 						for (let j = 0; j < _this.$refs[e][0].$attrs.data.sup_array[i].sup_array.length; j++) {

				// 							var delData3 = _this.$refs[e][0].$attrs.data.sup_array[i].sup_array[j].pass_action;

				// 							_this.arrayDel(delData3);

				// 						}

				// 					}

				// 				}

				// 			}

				// 		}

				// 		break;
				// 	case '2':

				// 		// 如果点击的二级元素被选中
				// 		if (!(_this.$refs[e][0].isChecked)) {

				// 			if (_this.$refs[e][0].$attrs.data.sup_array) {

				// 				// 将对应的三级选中
				// 				for (let i = 0; i < _this.$refs[e][0].$attrs.data.sup_array.length; i++) {

				// 					_this.array.push(_this.$refs[e][0].$attrs.data.sup_array[i].pass_action)

				// 					// 数组去重
				// 					_this.array = [...new Set(_this.array)];

				// 				}

				// 			}



				// 			// 将对应的一级选中
				// 			_this.array.push(firParent);

				// 			// 数组去重
				// 			_this.array = [...new Set(_this.array)];

				// 		} else {

				// 			if (_this.$refs[e][0].$attrs.data.sup_array) {

				// 				console.log();

				// 				// 遍历得到三级pass_action属性
				// 				for (let i = 0; i < _this.$refs[e][0].$attrs.data.sup_array.length; i++) {

				// 					// 需要在array中删除的数据
				// 					var delData3 = _this.$refs[e][0].$attrs.data.sup_array[i].pass_action;

				// 					_this.arrayDel(delData3);

				// 				}

				// 			}



				// 		}

				// 		break;
				// 	case '3':



				// 		// 如果点击的三级元素被选中
				// 		if (!(_this.$refs[e][0].isChecked)) {

				// 			// 将对应的一级选中
				// 			_this.array.push(firParent);

				// 			// 数组去重
				// 			_this.array = [...new Set(_this.array)];

				// 			// 将对应的二级选中
				// 			_this.array.push(secParent);

				// 			// 数组去重
				// 			_this.array = [...new Set(_this.array)];

				// 		}



				// 		break;
				// 	default:
				// 		break;
				// }


			},


			//初始化权限列表
			adminClassLists() {

				_this.$post(
					"/system/passAction"
				).then(res => {


					_this.check_lists = res.data;


				}).catch((err) => {

				})


			},
			cancel() {
				_this.show = false;
				_this.clear();
			},
			clear() {
				_this.submit_data = {
					name: '',
					synchronization: [],
					remarks: '',
					driver_wallet_add:'0',
					order_export_cp:'0',
					driver_sign_add:'0',
					driver_write_add:'0',
					consumer_recharge_add:'0',
					driver_driverpoints_add:'0',
					boss_login:'0',
					export_order_invoice:'0',
					export_bank_card:'0',
					export_order_count:'0',
					positioning_reward:'0'
				};


				_this.array = [];

				_this.assign_mode_submit = [];
			},
			toJSON(){
				_this.submit_data.assign_mode = JSON.stringify(_this.assign_mode_submit)
				//json格式化
				_this.submit_data.synchronization = JSON.stringify(_this.array);
			},

			// 添加角色
			onSubmitDig() {







					_this.clear();

					// 关闭添加弹窗
					_this.show = false;

					// 初始化页面
					var return_data = {
						page: 1,
						limit: 10,
						name: ''
					};



					_this.$emit("submit_ok_return", return_data);



				_this.array = [];

				_this.assign_mode_submit = [];
			}
		}
	}
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}


	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.formName {
		margin-left: 20px;
	}
</style>
